<script setup>
import { computed } from 'vue';
import HeroSection from '@/components/pages/HeroSection.vue';
import ShareBar from '@/components/pages/ShareBar.vue';
import InfoArea from '@/components/pages/InfoArea.vue';

const props = defineProps({
  // heroSectionData: Object,
  // shareBarData: Object,
  // infoAreaData: Object,
  event: Object,
  isLoading: Boolean,
});

const mapEventInfo = (event) => (event ? {
  // date: { start: event.startDateTime, end: event.endDateTime },
  // location: event.location,
  // subLocation: event.subLocation, // sublocation not in api yet
} : []);

const mapHeroSection = (event) => (event ? {
  url: `${process.env.VUE_APP_ASSET_PATH}${event.assetForWaitingRoom?.fileName}`,
  header: event.name,
  title: event.name,
  subTitle: event.description,
  buttonText: event.ctaLabel,
  alt: event.assetAltTextWaitingRoom,
} : []);

const mapShareBar = (event) => (event ? {
  header: event.name,
  type: event.typeEvent?.name,
} : []);

const mapInfoArea = (event) => (event ? {
  url: `${process.env.VUE_APP_ASSET_PATH}${event.assetForRegistration?.fileName}`,
  richTextContent: event.descriptionDetail,
} : []);

const eventInfo = computed(() => mapEventInfo(props.event));

</script>

<template>
  <!-- TODO This needs to be finished up -->
  <!-- <div class="text-lg absolute top-0 text-center min-w-full">
      {{ isLoading  ? 'Loading...' : '' }}
  </div> -->
  <div>
    <slot name="hero-section">
      <hero-section
        v-if="event"
        v-bind="mapHeroSection(event)"
        desc
      >
        <template v-slot:details>
          <slot name="hero-details"></slot>
        </template>
        <template v-slot:button>
          <slot name="hero-button"></slot>
        </template>
      </hero-section>
    </slot>
    <share-bar
      v-if="event"
      v-bind="mapShareBar(event)"
      :event-info="eventInfo"
      share
    >
      <template v-slot:details>
        <slot name="share-bar-details"></slot>
      </template>
    </share-bar>
    <info-area
      v-if="event"
      v-bind="mapInfoArea(event)"
      :event-info="eventInfo"
    >
      <template v-slot:details>
        <slot name="info-area-details">
         <!--
            This slot is for all the content of the info-area.
            This includes descriptionDetail, time, location, duration, etc. and cta button
          -->
        </slot>
      </template>
    </info-area>
  </div>
</template>
